import * as yup from 'yup';

export const investment_information_schema = {
  fieldOfWorkId: '',
  overallLocalInternationalInvestmentsPercentNetAssetsId: '',
  investmentKnowledgeAndExperienceId: '',
  whaIsTheInstitutionsRiskAppetite: '',
  noOfYearsOfInvestmentInSecuritiesId: '',
  investmentPortfolioTypeOfInvestments: [],
  whatIsTheInstitutionsDebtToInvestmentRatio: '',
  institutionMarginTransactionsPastFiveYearsId: '',
  estimateTotalVolumeOfYourInstitutionMarginInThePastFiveYears: '',
  hasInstitutionInvestedInFinancialSecuritiesOutsideKSA: '',
  investmentPortfolioCountries: [],
  investmentPortfolioPreferredCurrencies: [],
  whatIsTheInstitutionsGeneralInvestmentObjective: '',
  preferred_investment_assets: [],
  investmentPortfolioForeignCurrencies: [],
  whatIsInstitutionsExpectedTimeHorizonForRedeemingTheseInvestments: '',
  extentOfInvestmentAdviceReliabilityId: '',
  investmentActivitiesIncludedId: '',
  branchesInHighRiskCountriesId: '',
};

const investment_information_validation_schema = yup.object().shape({
  fieldOfWorkId: yup.number().required('this_field_is_required'),
  otherFieldOfWork: yup.string().when('fieldOfWorkId', {
    is: (val) => Number(val) === 1519,
    then: (schema) => schema.required('this_field_is_required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  overallLocalInternationalInvestmentsPercentNetAssetsId: yup
    .number()
    .required('this_field_is_required'),

  investmentKnowledgeAndExperienceId: yup
    .number()
    .required('this_field_is_required'),

  whaIsTheInstitutionsRiskAppetite: yup
    .number()
    .required('this_field_is_required'),

  noOfYearsOfInvestmentInSecuritiesId: yup
    .object()
    .required('this_field_is_required'),

  whatIsTheInstitutionsDebtToInvestmentRatio: yup
    .object()
    .required('this_field_is_required'),

  institutionMarginTransactionsPastFiveYearsId: yup
    .boolean()
    .required('this_field_is_required'),

  investmentPortfolioPreferredCurrencies: yup
    .array()
    .required('preferred_currency_is_required')
    .min(1, 'please_select_at_least_one'),

  whatIsTheInstitutionsGeneralInvestmentObjective: yup
    .array()
    .required('this_field_is_required'),

 investmentPortfolioForeignCurrencies: yup
    .array()
    .when('investmentPortfolioPreferredCurrencies', {
      is: (arr) => arr?.some((item) => item?.valueId === 790),
      then: (schema) =>
        schema.required('this_field_is_required')
              .min(1, 'please_select_at_least_one'),
      otherwise: (schema) => schema.notRequired(),
    }),

  whatIsInstitutionsExpectedTimeHorizonForRedeemingTheseInvestments: yup
    .object()
    .required('this_field_is_required'),

  extentOfInvestmentAdviceReliabilityId: yup
    .number()
    .required('this_field_is_required'),

  investmentActivitiesIncludedId: yup.boolean().nullable(),

  branchesInHighRiskCountriesId: yup.boolean().nullable(),

  investmentPortfolioTypeOfInvestments: yup
    .array()
    .required('type_of_investment_is_required')
    .min(1, 'please_select_at_least_one'),

  estimateTotalVolumeOfYourInstitutionMarginInThePastFiveYears: yup
    .string()
    .when('institutionMarginTransactionsPastFiveYearsId', {
      is: true,
      then: (schema) => schema.required('this_field_is_required'),
      otherwise: (schema) => schema.nullable(),
    }),

  hasInstitutionInvestedInFinancialSecuritiesOutsideKSA: yup
    .boolean()
    .required('this_field_is_required'),

  investmentPortfolioCountries: yup
    .array()
    .when('hasInstitutionInvestedInFinancialSecuritiesOutsideKSA', {
      is: true,
      then: (schema) =>
        schema
          .required('this_field_is_required')
          .min(1, 'please_select_at_least_one'),
      otherwise: (schema) => schema.notRequired(),
    }),

  investmentPortfolioTypeOfInvestmentsOtherSpecify: yup
    .string()
    .when('investmentPortfolioTypeOfInvestments', {
      is: (arr) => arr?.some((item) => item?.valueId === 74),
      then: (schema) => schema.required('this_field_is_required'),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export default investment_information_validation_schema;
